import React, { useEffect } from "react";
import { Helmet } from "react-helmet";

import NavBar from "../components/common/navBar";
import Footer from "../components/common/footer";
import Logo from "../components/common/logo";
import WorkstationTools from "../components/WorkstationTools/WorkstationTools";
import INFO from "../data/user";
import SEO from "../data/seo";

import "./styles/contact.css";

const Uses = () => {
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	const currentSEO = SEO.find((item) => item.page === "uses");

	return (
		<React.Fragment>
			<Helmet>
				<title>{`Uses | ${INFO.main.title}`}</title>
				<meta name="description" content={currentSEO.description} />
				<meta
					name="keywords"
					content={currentSEO.keywords.join(", ")}
				/>
			</Helmet>

			<div className="page-content">
				<NavBar active="Uses" />
				<div className="content-wrapper">
					<div className="contact-logo-container">
						<div className="contact-logo">
							<Logo width={46} />
						</div>
					</div>

					<div className="contact-container">
						<div className="title contact-title">
						Software and hardware I use and other tech things I'm into
						</div>

						<div className="subtitle contact-subtitle">
						For the fun of it, a list of my current workstation and the software I use on a daily basis as well as some of my favorite gadgets and other tech things I'm into.
						</div>
					</div>

					<div className="socials-container">
					<WorkstationTools/>
					</div>

					<div className="page-footer">
						<Footer />
					</div>
				</div>
			</div>
		</React.Fragment>
	);
};

export default Uses;
